/**
 * 매입 영수증 OCR 초안 저장소 (localStorage, BE 연결 전)
 *
 * 초안 = OCR 로 읽고 사람이 확인한 매입 내역. 아직 재고에는 반영되지 않은 상태(DRAFT).
 * 입고관리 연동 시: draftToStockInRows(tc, draft) 결과를 입고관리 저장 로직(shop StockIn.save)에 넘기고
 * markDraftApplied 로 상태를 바꾼다. (연동은 후속 — 지금은 초안 적재까지만)
 *
 * 초안 형태:
 *  { draftUid, receiptDate, vendorNm, imageName, ocrTotal, status:'DRAFT'|'APPLIED',
 *    lines:[{ name, qty, unitPrice, amount, productUid }], createdAt }
 */
import { loadTable, saveTable, createUid, num } from 'shop/shopStore';

const TABLE = 'receiptDraft';

export function loadDrafts(tc) {
  return loadTable(tc, TABLE).sort((a, b) => String(b.createdAt).localeCompare(String(a.createdAt)));
}

export function saveDraft(tc, draft) {
  const row = {
    draftUid: createUid('RCP'),
    status: 'DRAFT',
    ...draft,
    createdAt: new Date().toISOString(),
  };
  saveTable(tc, TABLE, [...loadTable(tc, TABLE), row]);
  return row;
}

export function removeDraft(tc, draftUid) {
  saveTable(tc, TABLE, loadTable(tc, TABLE).filter((d) => d.draftUid !== draftUid));
}

export function markDraftApplied(tc, draftUid) {
  saveTable(
    tc,
    TABLE,
    loadTable(tc, TABLE).map((d) => (d.draftUid === draftUid ? { ...d, status: 'APPLIED' } : d))
  );
}

/**
 * 초안 → 입고관리 행(StockIn 그리드 행 모양) 변환. 제품 매칭이 된 줄만 돌려준다.
 * 수량·단가는 영수증 기준 = 매입단위 기준으로 본다(StockIn 의 buyQty/buyUnitCost).
 */
export function draftToStockInRows(draft) {
  return (draft.lines || [])
    .filter((l) => l.productUid && num(l.qty) > 0)
    .map((l) => ({
      inDate: draft.receiptDate,
      productUid: l.productUid,
      buyQty: num(l.qty),
      buyUnitCost: num(l.unitPrice),
      vendorNm: draft.vendorNm || '',
      expiryDate: '',
      remark: `영수증 OCR ${draft.imageName || ''}`.trim(),
    }));
}
